export default {
  name: 'menu1-2-1',
  data() {
    return {};
  }
};